(function(){
  var d = document, PD = window.PD || {routes:{}};
  var header = d.querySelector('[data-pd-header]');
  var lightTop = d.body.getAttribute('data-light-top') === 'true';
  function onScroll(){
    if(!header) return;
    var y = window.scrollY;
    header.classList.toggle('is-scrolled', y > 30);
    var hero = d.querySelector('[data-pd-darktop]');
    var past = hero ? y > (hero.offsetTop + hero.offsetHeight - 90) : false;
    header.classList.toggle('is-light', lightTop || past);
  }
  window.addEventListener('scroll', onScroll, {passive:true}); onScroll();

  d.querySelectorAll('.pd-hero video, .pd-pdp__shot video, .pd-password video').forEach(function(v){
    v.muted = true; v.setAttribute('muted',''); v.setAttribute('playsinline',''); v.removeAttribute('controls');
    var p = v.play(); if(p && p.catch) p.catch(function(){});
  });

  /* bag */
  var drawer = d.querySelector('[data-pd-drawer]');
  function openCart(){
    if(!drawer){ location.href = PD.routes.cart; return; }
    drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden','false');
    d.documentElement.classList.add('pd-lock');
    var p = drawer.querySelector('.pd-drawer__panel'); if(p) p.focus({preventScroll:true});
  }
  function closeCart(){
    if(!drawer) return;
    drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden','true');
    d.documentElement.classList.remove('pd-lock');
  }
  function render(sections){
    if(!sections || !sections['pd-cart-drawer']) return;
    var tmp = d.createElement('div'); tmp.innerHTML = sections['pd-cart-drawer'];
    var fresh = tmp.querySelector('[data-pd-drawer-content]');
    var cur = d.querySelector('[data-pd-drawer-content]');
    if(fresh && cur){
      cur.parentNode.replaceChild(fresh, cur);
      var n = fresh.getAttribute('data-pd-count-value');
      d.querySelectorAll('[data-pd-cart-count]').forEach(function(el){ el.textContent = n; });
    }
  }
  function post(url, body){
    body.sections = 'pd-cart-drawer';
    body.sections_url = location.pathname;
    return fetch(url, {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify(body)})
      .then(function(r){ return r.json().then(function(j){ if(!r.ok) throw j; return j; }); });
  }
  function add(id, qty, btn){
    if(btn) btn.setAttribute('aria-busy','true');
    return post(PD.routes.cartAdd + '.js', {items:[{id:Number(id), quantity:qty}]})
      .then(function(j){ render(j.sections); openCart(); })
      .catch(function(err){ alert((err && (err.description || err.message)) || 'Could not add to bag.'); })
      .then(function(){ if(btn) btn.removeAttribute('aria-busy'); });
  }
  function change(key, qty){
    return post(PD.routes.cartChange + '.js', {id:key, quantity:qty})
      .then(function(j){ if(d.body.classList.contains('tpl-cart')){ location.reload(); return; } render(j.sections); })
      .catch(function(){ location.reload(); });
  }
  d.addEventListener('click', function(e){
    var t = e.target;
    if(t.closest('[data-pd-cart-open]')){ e.preventDefault(); openCart(); return; }
    if(t.closest('[data-pd-cart-close]')){ e.preventDefault(); closeCart(); return; }
    var q = t.closest('[data-pd-qty]'); if(q){ e.preventDefault(); change(q.getAttribute('data-key'), parseInt(q.getAttribute('data-pd-qty'), 10)); return; }
    var a = t.closest('[data-pd-add]'); if(a){ e.preventDefault(); add(a.getAttribute('data-pd-add'), 1, a); return; }
    var b = t.closest('[data-pd-back]');
    if(b && d.referrer && d.referrer.indexOf(location.origin) === 0 && history.length > 1){ e.preventDefault(); history.back(); return; }
    var f = t.closest('[data-pd-fit-toggle]');
    if(f){ e.preventDefault(); var det = d.querySelector(f.getAttribute('href')); if(det) det.open = !det.open; }
  });
  d.addEventListener('keydown', function(e){ if(e.key === 'Escape' && drawer && drawer.classList.contains('is-open')) closeCart(); });

  /* product */
  d.querySelectorAll('[data-pd-product]').forEach(function(root){
    var form = root.querySelector('form[action*="/cart/add"]');
    var dataEl = root.querySelector('[data-pd-variants]');
    var variants = []; try { variants = JSON.parse(dataEl.textContent); } catch(err) {}
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    var groups = root.querySelectorAll('[data-pd-option]');
    var pickLabel = root.getAttribute('data-pick-label') || 'Select a size';
    function update(push){
      var vals = [], complete = true;
      groups.forEach(function(g){
        var c = g.querySelector('input:checked');
        var st = g.querySelector('[data-pd-size-state]');
        if(c){ vals.push(c.value); if(st) st.textContent = c.value; } else { complete = false; vals.push(null); if(st) st.textContent = 'Select'; }
      });
      var v = null;
      if(complete){ v = variants.filter(function(x){ return x.options.every(function(o, i){ return o === vals[i]; }); })[0] || null; }
      var label, disabled;
      if(!complete){ label = pickLabel; disabled = true; }
      else if(!v || !v.available){ label = 'Sold out'; disabled = true; }
      else {
        label = 'Add to bag · ' + v.price; disabled = false;
        if(idInput) idInput.value = v.id;
        root.querySelectorAll('[data-pd-price]').forEach(function(el){ el.textContent = v.price; });
        if(push){ try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString()); } catch(err) {} }
      }
      root.querySelectorAll('[data-pd-add-label]').forEach(function(btn){
        var l = btn.querySelector('[data-pd-label]') || btn;
        l.textContent = btn.closest('.pd-mbar') && !disabled ? 'Add to bag' : label;
        btn.disabled = disabled;
      });
      if(groups.length){
        var last = groups[groups.length - 1], li = groups.length - 1;
        last.querySelectorAll('input').forEach(function(inp){
          var ok = variants.some(function(x){ return x.available && x.options[li] === inp.value && x.options.every(function(o, i){ return i === li || vals[i] === null || o === vals[i]; }); });
          var lab = root.querySelector('label[for="' + inp.id + '"]'); if(lab) lab.classList.toggle('is-out', !ok);
        });
      }
    }
    root.addEventListener('change', function(e){ if(e.target.closest('[data-pd-option]')) update(true); });
    if(form){
      form.addEventListener('submit', function(e){
        e.preventDefault();
        var btn = form.querySelector('[type="submit"]');
        if(!idInput || !idInput.value || (btn && btn.disabled)) return;
        add(idInput.value, 1, btn);
      });
    }
    update(false);
  });

  /* shop filter chips */
  d.addEventListener('click', function(e){
    var c = e.target.closest('[data-pd-filter]'); if(!c) return;
    var v = c.getAttribute('data-pd-filter');
    d.querySelectorAll('[data-pd-filter]').forEach(function(b){ b.classList.toggle('is-on', b === c); });
    d.querySelectorAll('[data-pd-type]').forEach(function(el){ el.hidden = !(v === 'all' || el.getAttribute('data-pd-type') === v); });
  });

  /* info: open the FAQ item in the URL hash */
  function openHash(){
    var h = location.hash.slice(1); if(!h) return;
    var el = d.getElementById(decodeURIComponent(h));
    if(el && el.tagName === 'DETAILS'){ el.open = true; }
  }
  openHash(); window.addEventListener('hashchange', openHash);

  /* shipping country */
  var cm = d.querySelector('[data-pd-country]');
  if(cm){
    var openC = function(){ cm.classList.add('is-open'); cm.setAttribute('aria-hidden','false'); d.documentElement.classList.add('pd-lock'); var p = cm.querySelector('.pd-country__panel'); if(p) p.focus({preventScroll:true}); };
    var closeC = function(){ cm.classList.remove('is-open'); cm.setAttribute('aria-hidden','true'); d.documentElement.classList.remove('pd-lock'); try { localStorage.setItem('pd-country-seen','1'); } catch(err) {} };
    d.addEventListener('click', function(e){
      if(e.target.closest('[data-pd-country-open]')){ e.preventDefault(); openC(); }
      else if(e.target.closest('[data-pd-country-close]')){ e.preventDefault(); closeC(); }
    });
    var cf = cm.querySelector('form'); if(cf) cf.addEventListener('submit', function(){ try { localStorage.setItem('pd-country-seen','1'); } catch(err) {} });
    d.addEventListener('keydown', function(e){ if(e.key === 'Escape' && cm.classList.contains('is-open')) closeC(); });
  }

})();
